var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 43,
    viewBox: "0 0 45 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.045 1.0303L29.9697 13.0963L43.2178 15.0312C44.7254 15.2513 45.3273 17.1135 44.2365 18.1823L34.65 27.5743L36.913 40.8362C37.1705 42.3453 35.5946 43.4961 34.2462 42.7836L22.3967 36.5222L10.5473 42.7836C9.19893 43.4961 7.62294 42.3453 7.8805 40.8362L10.1435 27.5743L0.557046 18.1822C-0.533829 17.1134 0.0681689 15.2514 1.57575 15.0311L14.8238 13.0963L20.7485 1.0303C21.4228 -0.342782 23.3707 -0.342782 24.045 1.0303Z",
    fill: "url(#paint0_linear_2900_1557)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9703 13.0958L24.0456 1.02979C23.7085 0.343292 23.053 0 22.3975 0V22.8441L29.9703 13.0958Z",
    fill: "url(#paint1_linear_2900_1557)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6507 27.5737L44.2371 18.1816C44.7752 17.6543 44.9008 16.9342 44.7095 16.3132L22.3975 22.844L34.6507 27.5737Z",
    fill: "url(#paint2_linear_2900_1557)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.188 42.6382L22.3975 22.844V36.5217L34.2469 42.7831C34.9235 43.1406 35.6573 43.0288 36.188 42.6382Z",
    fill: "url(#paint3_linear_2900_1557)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3957 22.844L10.1424 27.5738L7.87945 40.8356C7.75111 41.5874 8.07814 42.2502 8.60507 42.6382L22.3957 22.844Z",
    fill: "url(#paint4_linear_2900_1557)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0859375 16.3131L22.3979 22.8438L14.8251 13.0955L1.57698 15.0304C0.81313 15.1419 0.282433 15.6752 0.0859375 16.3131Z",
    fill: "url(#paint5_linear_2900_1557)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.143 27.5736L0.556521 18.1816C0.0183884 17.6543 -0.107156 16.9342 0.0841787 16.3132L22.3962 22.8439L10.143 27.5736Z",
    fill: "url(#paint6_linear_2900_1557)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2900_1557",
    x1: 22.3974,
    y1: 5.01523,
    x2: 22.3974,
    y2: 54.6919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    stopColor: "#FFC954"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2900_1557",
    x1: 34.0074,
    y1: 11.4209,
    x2: 19.0665,
    y2: 11.4209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC200",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#FFBB00",
    stopOpacity: 0.203
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#FFA700",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#FF8800",
    stopOpacity: 0.852
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2900_1557",
    x1: 36.5598,
    y1: 34.4289,
    x2: 32.5641,
    y2: 14.8517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC200",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#FFBB00",
    stopOpacity: 0.203
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#FFA700",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#FF8800",
    stopOpacity: 0.852
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2900_1557",
    x1: 17.3737,
    y1: 44.7214,
    x2: 32.9497,
    y2: 29.2245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC200",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#FFBB00",
    stopOpacity: 0.203
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#FFA700",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#FF8800",
    stopOpacity: 0.852
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2900_1557",
    x1: 6.32064,
    y1: 25.0238,
    x2: 17.7911,
    y2: 34.5713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC200",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#FFBB00",
    stopOpacity: 0.203
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#FFA700",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#FF8800",
    stopOpacity: 0.852
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2900_1557",
    x1: 14.8858,
    y1: 9.17988,
    x2: 10.2149,
    y2: 22.3718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC200",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#FFBB00",
    stopOpacity: 0.203
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#FFA700",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#FF8800",
    stopOpacity: 0.852
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2900_1557",
    x1: 32.3079,
    y1: 10.5592,
    x2: -1.75172,
    y2: 24.9917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC200",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#FFBB00",
    stopOpacity: 0.203
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#FFA700",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#FF8800",
    stopOpacity: 0.852
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7800"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.5e10df8372b4bbfd8d6d8f273cf081cb.svg";
export { ForwardRef as ReactComponent };